import script from "./MazdaPluginPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MazdaPluginPanel.vue?vue&type=script&setup=true&lang=js"

import "./MazdaPluginPanel.vue?vue&type=style&index=0&id=3ef6395c&scoped=true&lang=css"
import "./MazdaPluginPanel.vue?vue&type=style&index=1&id=3ef6395c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ef6395c"]])

export default __exports__